module.exports = {
        srcSet: __webpack_public_path__ + "shell-banner-half-night-772-bb2d1cc968817d05.digested.webp"+" 772w",
        images: [{path: __webpack_public_path__ + "shell-banner-half-night-772-bb2d1cc968817d05.digested.webp",width: 772,height: 320}],
        src: __webpack_public_path__ + "shell-banner-half-night-772-bb2d1cc968817d05.digested.webp",
        toString: function(){return __webpack_public_path__ + "shell-banner-half-night-772-bb2d1cc968817d05.digested.webp"},
        
        width: 772,
        height: 320
      }